import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getFieldsData = store => store[NAME].fieldsData;
export const getSubTypeList = store => store[NAME].subTypeList;
export const getTypeList = store => store[NAME].typeList;